import { render, staticRenderFns } from "./EmotionCommentsModal.vue?vue&type=template&id=519e1efa"
import script from "./EmotionCommentsModal.vue?vue&type=script&lang=js"
export * from "./EmotionCommentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519e1efa')) {
      api.createRecord('519e1efa', component.options)
    } else {
      api.reload('519e1efa', component.options)
    }
    module.hot.accept("./EmotionCommentsModal.vue?vue&type=template&id=519e1efa", function () {
      api.rerender('519e1efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/ClassOverviewDetail/components/MoodRecordDetail/components/EmotionCommentsModal.vue"
export default component.exports